import request from '../../axios';
import {availableLoanTypeResponse} from './types';

export const getAvailableLoanTypes = async () => {
  const {data}: {data: availableLoanTypeResponse} = await request.get(
    `/api/v2/payment/check-available-loan-type`,
  );

  return data;
};
